
import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './SideBarButton.scss';

class SideBarButton extends React.Component {
  static propTypes = {
    link: PropTypes.string,
    text: PropTypes.string.isRequired,
    isCollapsable: PropTypes.bool,
    active: PropTypes.bool,
    counter: PropTypes.number,
    children: PropTypes.array,
    showChildren: PropTypes.bool,
  };

  state = {
    showChildren: false,
  }

  // style={{width: `${this.props.width}px` }} 

  onMouseEnter = () => this.setState({ showChildren: true });
  onMouseLeave = () => this.setState({ showChildren: false });

  render() {
    return (
      <div onMouseEnter={() => this.onMouseEnter()} onMouseLeave={() => this.onMouseLeave()} style={{position: 'relative', top: this.props.isSubMenu ? '-50px' : '0', left: this.props.isSubMenu ? '250px' : '0' }} className={this.props.active ? "side-bar-button active" : "side-bar-button"}>
        <a className={this.props.icon} href={`${this.props.link}`}>{this.props.text.toUpperCase()}
          {this.props.isCollapsable && <i className="collapsable" />}
          {this.props.counter && <i className="counter">{this.props.counter}</i>}
        </a>
        {this.props.children && this.state.showChildren && this.props.children.map((child, i) => {
          return React.cloneElement(child, {
            key: i,
            isSubMenu: true,
          })
        })}
      </div>
    );
  }
}

export default withStyles(s)(SideBarButton);



// WEBPACK FOOTER //
// src/components/SideBarMenu/SideBarButton/SideBarButton.js